import { render, staticRenderFns } from "./ProductsServicesPane.vue?vue&type=template&id=27af892e&"
import script from "./ProductsServicesPane.vue?vue&type=script&lang=ts&"
export * from "./ProductsServicesPane.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports